import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import NavigateBack from "../../components/navigateBack";
import SingleChoice from "../../components/singleChoice";
import { Wizard } from "react-use-wizard";
import { useState, useEffect } from "react";
import SelectDoctor from "./selectDoctor";
import ConfirmChangeDoctor from "./confirmChangeDoctor";

const useTokenState = createPersistedState("token");
const useProfile = createPersistedState("profile");
const useClinicState = createPersistedState("clinic");

const filterDoctorsForClinic = (doctors, clinicId) => {
  if (!Array.isArray(doctors) || !clinicId) return [];

  return doctors.filter((doctor) =>
    doctor?.clinics?.some((clinic) => clinic.code === clinicId)
  );
};

const SwitchDoctorPage = () => {
  const history = useHistory();
  const location = useLocation();

  const [token, _] = useTokenState();
  const [clinic, __] = useClinicState();
  const [profile, setProfile] = useProfile();

  const queryParams = new URLSearchParams(location.search);
  const queryParamClinicId = queryParams.get("cid")?.toUpperCase();

  const [isFetchingData, setIsFetchingData] = useState(false);
  const [availableDoctors, setAvailableDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState();

  const fetchDoctorClinicInfo = async () => {
    const DOCTOR_CLINIC_URL = `/api/v1/users/register/settings`;
    try {
      setIsFetchingData(true);

      const doctorClinicResponse = await fetch(DOCTOR_CLINIC_URL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      if (!doctorClinicResponse.ok) {
        throw new Error(`HTTP error! Status: ${doctorClinicResponse.status}`);
      }

      const doctorClinicData = await doctorClinicResponse.json();

      if (doctorClinicData.status?.code === 200) {
        setAvailableDoctors(
          filterDoctorsForClinic(doctorClinicData.doctors, queryParamClinicId)
        );
      } else {
        console.error("Unexpected API response:", doctorClinicData);
      }
    } catch (error) {
      console.error("Error fetching doctor clinic info:", error);
    } finally {
      setIsFetchingData(false);
    }
  };

  useEffect(() => {
    fetchDoctorClinicInfo();
  }, []);

  if (isFetchingData)
    return (
      <div>
        <NavigateBack />
        <div
          style={{
            margin: "auto",
            marginTop: "6em",
            display: "flex",
            justifyContent: "center",
          }}
          id="loader"
        ></div>
      </div>
    );

  return (
    <>
      <Wizard startIndex={0}>
        <SelectDoctor
          availableDoctors={availableDoctors}
          onSubmitHandler={(selectedDoctor) => {
            setSelectedDoctor(
              availableDoctors.find(
                (availableDoctors) =>
                  availableDoctors?.code === selectedDoctor?.value
              )
            );
          }}
        />
        <ConfirmChangeDoctor
          selectedDoctor={selectedDoctor}
          queryParamClinicId={queryParamClinicId}
        />
      </Wizard>
    </>
  );
};

export default SwitchDoctorPage;
